import { ConfigResult } from "../../services/services-model.type";
import {
  SET_LANGUAGE,
  SET_SESSION_ID,
  SET_IS_CONNECTED,
  SET_PUSH_ID,
  FETCH_CONFIG_REQUEST,
  FETCH_CONFIG_SUCCESS,
  FETCH_CONFIG_FAILURE,
} from "./actions.type";
import {
  SetSessionID,
  SetLanguage,
  SetPushID,
  SetConnectedStatus,
  FetchConfigRequest,
  FetchConfigSuccess,
  FetchConfigFailure,
} from "./types";

export const setSessionID = (payload: string): SetSessionID => ({
  type: SET_SESSION_ID,
  payload,
});

export const setLanguage = (payload: string): SetLanguage => ({
  type: SET_LANGUAGE,
  payload,
});

export const setPushID = (payload: string): SetPushID => ({
  type: SET_PUSH_ID,
  payload,
});

export const setConnectedStatus = (payload: boolean): SetConnectedStatus => ({
  type: SET_IS_CONNECTED,
  payload,
});

export const fetchConfigRequest = (): FetchConfigRequest => ({
  type: FETCH_CONFIG_REQUEST,
});

export const fetchConfigSuccess = (payload?: ConfigResult): FetchConfigSuccess => ({
  type: FETCH_CONFIG_SUCCESS,
  payload,
});

export const fetchConfigFailure = (): FetchConfigFailure => ({
  type: FETCH_CONFIG_FAILURE,
});
